import React from "react";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { UserResource } from "../../../../api/users";

interface SendPushRequestBody {
  title: string;
  body: string;
}

interface SendNotificationFormProps {
  userId: string;
  userName: string;
  onClose: () => void;
}

export const SendNotificationForm: React.FC<SendNotificationFormProps> = ({
  userId,
  userName,
  onClose,
}) => {
  const [response, setResponse] = React.useState<string>("");
  const [title, setTitle] = React.useState("");
  const [body, setBody] = React.useState("");

  const onSend = async () => {
    const pushBody: SendPushRequestBody = { title, body };

    setResponse("Sending notification...");
    try {
      await UserResource.sendPush(userId, pushBody);
      onClose();
    } catch (e) {
      console.error("Error sending notification: ", e);
      setResponse("Error sending notification: " + e);
    }
  };
  return (
    <DialogContent
      sx={{
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Typography variant="h5">Send notification to {userName}</Typography>
      <TextField
        label="Title"
        required
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <TextField
        label="Body"
        required
        value={body}
        multiline
        onChange={(e) => setBody(e.target.value)}
      />
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSend} variant="contained">
          Send Notification
        </Button>
      </DialogActions>
      <Box sx={{ overflowY: "auto", height: "auto" }}>
        <Typography>{response}</Typography>
      </Box>
    </DialogContent>
  );
};
